export enum EChannelProvider {
  SMS = 'SMS',
  EMAIL = 'Email',
  WHATSAPP = 'WhatsApp',
  OUTLOOK = 'Outlook',
  FACEBOOK = 'Facebook',
  LINE = 'Line',
  LIVE_CHAT = 'Copilot',
}
